import { lazy } from "react";
import Loadable from "../components/loadable/Loadable";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../views/login/Login";
import { Navigate } from "react-router-dom";
import GuestUser from "../views/guest-user/GuestUser";
import PhotoUpload from "../views/photo-upload/PhotoUpload";

const LandingPage = Loadable(lazy(() => import("../auth/LandingPage")));
const Dashboard = Loadable(lazy(() => import("../views/dashboard/Dashboard")));
const LabelCatalog = Loadable(
  lazy(() => import("../views/label-catalog/LabelCatalog"))
);
const Quickorders = Loadable(
  lazy(() => import("../views/quick-order/QuickOrder"))
);
const Orderhistory = Loadable(
  lazy(() => import("../views/order-history/OrderHistory"))
);
const Draftorder = Loadable(
  lazy(() => import("../views/draft-order/DraftOrder"))
);
const ProfileView = Loadable(lazy(() => import("../views/profile/Profile")));
const ContactUsView = Loadable(
  lazy(() => import("../views/contact-us/ContactUs"))
);

const MainRoutes = [
  {
    path: "/",
    element: <Navigate to="/web-transport-landing?key=null" replace />,
  },
  {
    path: "/web-transport-landing",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/guestorder",
    element: <GuestUser />,
  },
  {
    path: "/validateupload",
    element: <PhotoUpload />,
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        path: "home",
        element: <Dashboard />,
      },
      {
        path: "label-catalog",
        element: <LabelCatalog />,
      },
      {
        path: "quick-order",
        element: <Quickorders />,
      },
      {
        path: "draft-order",
        element: <Draftorder />,
      },
      {
        path: "order-history",
        element: <Orderhistory />,
      },
      {
        path: "profile",
        element: <ProfileView />,
      },
      {
        path: "contact-us",
        element: <ContactUsView />,
      },
      {
        path: "*",
        element: <Navigate to="/home" />,
      },
    ],
  },
];

export default MainRoutes;
